import { render, staticRenderFns } from "./Efemerides.vue?vue&type=template&id=00586ce3&scoped=true&"
import script from "./Efemerides.vue?vue&type=script&lang=ts&"
export * from "./Efemerides.vue?vue&type=script&lang=ts&"
import style0 from "./Efemerides.vue?vue&type=style&index=0&id=00586ce3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00586ce3",
  null
  
)

export default component.exports